<div class="py-8 px-4 rounded-border flex items-center justify-between gap-5">
  <div>
    <img
      role="presentation"
      [alt]="file().name"
      [src]="file().objectURL"
      width="100"
      height="50"
    />
  </div>
  <div class="flex flex-col">
    <span class="filename">{{ file().name }}</span>
    <span class="block">
      {{ formatSize(file().size) }}
    </span>
  </div>
  @if (showRemove()) {
    <p-button
      icon="pi pi-times"
      text
      severity="danger"
      (click)="onRemove($event)"
    />
  }
</div>
